/* HY Background swatches: keeps the theme's variant id in sync and swaps the main image. No dependencies. */
(function(){
  function init(root){
    if(root.__hyBg) return; root.__hyBg = true;
    var variants = JSON.parse(root.querySelector('[data-hy-bg-variants]').textContent);
    var pos = parseInt(root.getAttribute('data-option-position'),10);
    var form = root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var current = root.querySelector('[data-hy-bg-current]');

    function selectedOptions(){
      // start from current variant, then apply every option input currently selected on the page
      var idInput = form && form.querySelector('[name="id"]');
      var cur = variants.find(function(v){ return idInput && String(v.id) === String(idInput.value); }) || variants[0];
      var opts = cur.options.slice();
      document.querySelectorAll('[name^="options["]').forEach(function(el){
        if((el.type === 'radio' && !el.checked)) return;
        var name = el.name.slice(8,-1);
        var idx = -1;
        if(el.closest('[data-hy-bg]')) idx = parseInt(el.closest('[data-hy-bg]').getAttribute('data-option-position'),10)-1;
        else if(el.dataset.optionPosition) idx = parseInt(el.dataset.optionPosition,10)-1;
        if(idx >= 0) opts[idx] = el.value;
      });
      return opts;
    }

    function onChange(e){
      var input = e.target;
      if(!input.classList.contains('hy-bg__input')) return;
      if(current) current.textContent = input.value;
      var opts = selectedOptions();
      opts[pos-1] = input.value;
      var match = variants.find(function(v){ return v.options.every(function(o,i){ return o === opts[i]; }); })
               || variants.find(function(v){ return v.options[pos-1] === input.value; });
      if(!match) return;
      if(form){
        var id = form.querySelector('[name="id"]');
        if(id){ id.value = match.id; id.dispatchEvent(new Event('change',{bubbles:true})); }
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
      var main = document.querySelector('[data-hy-main-image]');
      if(main && match.featured_image){
        main.src = match.featured_image.src; main.removeAttribute('srcset');
        main.alt = match.featured_image.alt || input.value;
      }
      document.dispatchEvent(new CustomEvent('hy:variant-change',{detail:{variant:match}}));
    }
    root.addEventListener('change', onChange);
  }
  function boot(){ document.querySelectorAll('[data-hy-bg]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
